import {
    ROUTE_TYPE
} from './constants';

// Icons import
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import SettingsIcon from "@material-ui/icons/Settings";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import DocumentCenter from "../components/dashboard/Dashboard";
import Login from "../pages/Login/Login";
import ManageUsersTable from "../components/settings/ManageUsers/ManageUsersTable";
import FileManager from "../components/filemanager/FileManager";
import Todo from "../components/task/Task";
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import ManageCompanyTable from "../components/settings/ManageCompany/ManageCompanyTable";
import StoreIcon from '@material-ui/icons/Store';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import ManageFolder from "../components/settings/ManageFolder/ManageFolder";
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import LoanReport from "../components/loanReport/LoanReport";
import ProfitTracker from "../components/profitTracker/ProfitTracker";
import ShowChartIcon from '@mui/icons-material/ShowChart';
import InvestmentTracker from "../components/investorTracker/InvestmentTracker";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessTracker from "../components/businessTracker/BusinessTracker";
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import RealEstate from "../components/realEstate/RealEstate";
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';

/**
 * {
 *  id: Route id,
 *  name: Name of route,
 *  path: location,
 *  component: React component,
 *  icon: icon name for sidebar,
 *  sidebar: show on sidebar link or no, true or false
 * }
 */

export const routes = [
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'login',
        label: 'Login',
        icon: VpnKeyIcon,
        path: '/login',
        component: Login,
        sidebar: false
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        path: '/file-manager',
        component: FileManager,
        sidebar: false,
    },
]
export const protectedRoutes = [
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'business-tracker',
        label: 'Business Tracker',
        icon: BusinessCenterIcon,
        path: '/business-tracker',
        component: BusinessTracker,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'document-center',
        label: 'Document Center',
        icon: FolderOpenIcon,
        sidebar: true,
        path: '/document-center',
        component: DocumentCenter,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'todo',
        label: 'Task',
        icon: PlaylistAddCheckIcon,
        path: '/task',
        component: Todo,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'loans',
        label: 'Loans',
        icon: LocalAtmIcon,
        sidebar: true,
        path: '/loans',
        component: LoanReport,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'profit-tracker',
        label: 'Profit Tracker',
        icon: ShowChartIcon,
        sidebar: true,
        path: '/profit-tracker',
        component: ProfitTracker,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'investor-tracker',
        label: 'Investor Tracker',
        icon: AccountBalanceIcon,
        sidebar: true,
        path: '/investor-tracker',
        component: InvestmentTracker,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    {
        type: ROUTE_TYPE.MENU_ITEM,
        id: 'real-estate',
        label: 'Real Estate',
        icon: MapsHomeWorkIcon,
        sidebar: true,
        path: '/real-estate',
        component: RealEstate,
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
    // {
    //     type: ROUTE_TYPE.SUB_MENU,
    //     id: 'accounting',
    //     label: 'Accounting',
    //     icon: SummarizeIcon,
    //     sidebar: true,
    //     submenuItems: [
    //         {
    //             type: ROUTE_TYPE.MENU_ITEM,
    //             id: 'profits',
    //             label: 'Profits',
    //             icon: InsightsIcon,
    //             sidebar: true,
    //             path: '/accounting/profits',
    //             component: WeeklyProfit
    //         }
    //     ]
    // },
    // {
    //     type: ROUTE_TYPE.DIVIDER,
    //     sidebar: true,
    // },
    // {
    //     type: ROUTE_TYPE.SUB_MENU,
    //     id: 'liz-accounting',
    //     label: 'Liz Accounting',
    //     icon: SummarizeIcon,
    //     sidebar: true,
    //     submenuItems: [
    //         {
    //             type: ROUTE_TYPE.MENU_ITEM,
    //             id: 'gameroom-accounting',
    //             label: 'GM Profits',
    //             icon: AssignmentIcon,
    //             sidebar: true,
    //             path: '/accounting/gameroom-accounting',
    //             component: LizAccounting
    //         },
    //         {
    //             type: ROUTE_TYPE.MENU_ITEM,
    //             id: 'atm',
    //             label: 'ATM Records',
    //             icon: AssignmentIcon,
    //             sidebar: true,
    //             path: '/accounting/atm-receipt',
    //             component: ATMReceipt
    //         },
    //     ]
    // },
    //
    // {
    //     type: ROUTE_TYPE.DIVIDER,
    //     sidebar: true,
    // },
    {
        type: ROUTE_TYPE.SUB_MENU,
        id: 'settings',
        label: 'Settings',
        icon: SettingsIcon,
        sidebar: true,
        submenuItems: [
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'company',
                label: 'Manage Company',
                icon: StoreIcon ,
                sidebar: true,
                path: '/settings/manage-company',
                component: ManageCompanyTable
            },
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'folder',
                label: 'Manage Folder',
                icon: FolderSpecialIcon ,
                sidebar: true,
                path: '/settings/manage-folder',
                component: ManageFolder
            },
            {
                type: ROUTE_TYPE.MENU_ITEM,
                id: 'manage-users',
                label: 'Manage Employee',
                icon: SupervisorAccountIcon,
                sidebar: true,
                path: '/settings/manage-employee',
                component: ManageUsersTable
            }
        ]
    },
    {
        type: ROUTE_TYPE.DIVIDER,
        sidebar: true,
    },
];

export const getSubmenuRoutes = (submenuItems) => {
    let submenuRoutes = [];
    submenuItems.map(item => {
        if (item.type === ROUTE_TYPE.MENU_ITEM) {
            submenuRoutes = [...submenuRoutes, item];
        } else if (item.type === ROUTE_TYPE.SUB_MENU) {
            submenuRoutes = [...submenuRoutes, ...getSubmenuRoutes(item.submenuItems)]
        }

        return item;
    });

    return submenuRoutes;
}

export const getRoutes = () => {
    return [...getSubmenuRoutes(protectedRoutes)]
}